import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '../styles/use-theme.js';
import { radius, spacing, typography } from '../styles/theme.js';
import { NotebookIcon, FavoriteIcon, ArchiveIcon, PlusIcon } from './icons.js';
const ENTRY_LABELS = [
    {
        id: 'all',
        label: '全部笔记',
        icon: (active) => (_jsx("span", { style: { fontSize: typography.fontSize.md, opacity: active ? 1 : 0.7 }, children: "\uD83D\uDCDD" })),
    },
    {
        id: 'favorites',
        label: '我的收藏',
        icon: (active) => (_jsx("span", { style: { display: 'inline-flex', color: active ? '#f59e0b' : 'currentColor', opacity: 0.9 }, children: _jsx(FavoriteIcon, {}) })),
    },
    {
        id: 'archived',
        label: '已归档',
        icon: () => (_jsx("span", { style: { display: 'inline-flex' }, children: _jsx(ArchiveIcon, {}) })),
    },
];
export function NoteSidebar({ notebooks, selected, selectedNotebookId, onSelect, onManageNotebooks, compact = false, }) {
    const { theme } = useTheme();
    const itemStyle = (active) => ({
        display: 'flex',
        alignItems: 'center',
        gap: spacing.sm,
        width: '100%',
        padding: compact ? `${spacing.xs} ${spacing.sm}` : `${spacing.sm} ${spacing.md}`,
        border: 'none',
        background: active ? theme.interaction.selected : 'transparent',
        borderRadius: radius.md,
        color: active ? theme.text.primary : theme.text.secondary,
        fontSize: typography.fontSize.base,
        fontWeight: active ? typography.fontWeight.medium : typography.fontWeight.normal,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        textAlign: 'left',
        transition: 'background-color 0.12s ease, color 0.12s ease',
    });
    const sectionTitle = {
        margin: `${spacing.md} ${spacing.sm} ${spacing.xs}`,
        fontSize: typography.fontSize.xs,
        color: theme.text.tertiary,
        fontWeight: typography.fontWeight.semibold,
        letterSpacing: '0.04em',
    };
    const notebookList = notebooks.map(nb => {
        const active = selected === 'notebook' && selectedNotebookId === nb._id;
        return (_jsxs("button", { onClick: () => onSelect('notebook', nb._id), style: itemStyle(active), children: [_jsx("span", { style: { display: 'inline-flex', color: nb.color ?? theme.text.tertiary }, children: nb.icon ? _jsx("span", { children: nb.icon }) : _jsx(NotebookIcon, {}) }), _jsx("span", { style: { flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }, children: nb.name }), !compact && (_jsx("span", { style: { fontSize: typography.fontSize.xs, color: theme.text.tertiary, flexShrink: 0 }, children: nb.noteCount }))] }, nb._id));
    });
    const entryButtons = ENTRY_LABELS.map(entry => {
        const active = selected === entry.id;
        return (_jsxs("button", { onClick: () => onSelect(entry.id), style: itemStyle(active), children: [entry.icon(active), _jsx("span", { children: entry.label })] }, entry.id));
    });
    const manageBtn = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: spacing.xs,
        width: '100%',
        marginTop: compact ? 0 : spacing.sm,
        padding: `${spacing.xs} ${spacing.sm}`,
        border: `1px dashed ${theme.border.hover}`,
        borderRadius: radius.md,
        background: 'transparent',
        color: theme.text.secondary,
        fontSize: typography.fontSize.sm,
        cursor: 'pointer',
        transition: 'color 0.12s ease, border-color 0.12s ease',
    };
    return (_jsx("div", { style: { display: 'flex', flexDirection: 'column', gap: compact ? 2 : 0 }, children: compact ? (_jsxs("div", { style: { display: 'flex', gap: spacing.xs, overflowX: 'auto', paddingBottom: spacing.xs }, children: [entryButtons, notebookList] })) : (_jsxs(_Fragment, { children: [entryButtons, _jsx("div", { style: sectionTitle, children: "\u7B14\u8BB0\u672C" }), notebookList, _jsxs("button", { onClick: onManageNotebooks, style: manageBtn, children: [_jsx(PlusIcon, {}), _jsx("span", { children: "\u7BA1\u7406\u7B14\u8BB0\u672C" })] })] })) }));
}
//# sourceMappingURL=note-sidebar.js.map